import React, { useState, useEffect, lazy, Suspense } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import SecondaryLayout from './SecondaryLayout'
import NotFound from '../Utilities/NotFound'
import 'react-loading-skeleton/dist/skeleton.css'

const Mainpage = lazy(() => import(/* webpackChunkName: "page-mainpage" */ './Mainpage'))
const Aboutus = lazy(() => import(/* webpackChunkName: "page-aboutus" */ '../Site/Aboutus/Aboutus'))
const Camps = lazy(() => import(/* webpackChunkName: "page-camps" */ '../Site/Camps/Camps'))
const Gallery = lazy(() => import(/* webpackChunkName: "page-gallery" */ '../Site/Gallery/Gallery'))
const Videoteka = lazy(() => import(/* webpackChunkName: "page-videoteka" */ '../Site/Videoteka/Videoteka'))
const SpecificCamps = lazy(() => import(/* webpackChunkName: "page-specific-camps" */ '../Site/Camps/SpecificCamps'))
const Camp = lazy(() => import(/* webpackChunkName: "page-camp" */ '../Site/Camps/Camp/Camp'))
const Reservation = lazy(() => import(/* webpackChunkName: "page-reservation" */ '../Site/Reservation/Reservation'))
const Forparents = lazy(() => import(/* webpackChunkName: "page-forparents" */ '../Site/Forparents/Forparents'))
const Opinions = lazy(() => import(/* webpackChunkName: "page-opinions" */ '../Site/Opinions/Opinions'))
const Contact = lazy(() => import(/* webpackChunkName: "page-contact" */ '../Site/Contact/Contact'))
const Blog = lazy(() => import(/* webpackChunkName: "page-blog" */ '../Site/Blog/Blog'))
const Article = lazy(() => import(/* webpackChunkName: "page-article" */ '../Site/Blog/Article/Article'))
const Discounts = lazy(() => import(/* webpackChunkName: "page-discounts" */ '../Site/Discounts/Discounts'))
const Faq = lazy(() => import(/* webpackChunkName: "page-faq" */ '../Site/Faq/Faq'))
const Team = lazy(() => import(/* webpackChunkName: "page-team" */ '../Site/Team/Team'))
const TermsOfParticipations = lazy(() => import(/* webpackChunkName: "page-terms" */ '../Site/TermsOfParticipation/TermsOfParticipations'))
const Insurance = lazy(() => import(/* webpackChunkName: "page-insurance" */ '../Site/Insurance/Insurance'))
const CookiesPolicy = lazy(() => import(/* webpackChunkName: "page-cookies-policy" */ '../Site/Cookies/Cookies'))
const PrivacyPolicy = lazy(() => import(/* webpackChunkName: "page-privacy" */ '../Site/PrivacyPolicy/PrivacyPolicy'))
const Resort = lazy(() => import(/* webpackChunkName: "page-resort" */ '../Site/Resort/Resort'))
const WhyWithUs = lazy(() => import(/* webpackChunkName: "page-whywithus" */ '../Site/WhyWithUs/WhyWithUs'))
const Equipment = lazy(() => import(/* webpackChunkName: "page-equipment" */ '../Site/Equipment/Equipment'))
const Transport = lazy(() => import(/* webpackChunkName: "page-transport" */ '../Site/Transport/Transport'))

export default function Layout(props) {
    useEffect(() => {
        let loaded = false
        const loadRecaptcha = () => {
            if (loaded) return
            loaded = true
            const script = document.createElement('script')
            script.src = 'https://www.google.com/recaptcha/api.js?render=6LdTadgZAAAAAI4lkks7Mqo1HgWKVl6xgJMNSryP'
            script.async = true
            document.body.appendChild(script)
        }
        window.addEventListener('scroll', loadRecaptcha, { once: true, passive: true })
        window.addEventListener('click', loadRecaptcha, { once: true })
        window.addEventListener('touchstart', loadRecaptcha, { once: true, passive: true })
    }, [])
    return (
        <>
            <div className="viacamp">
                <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
                <Switch>
                    <Route path="/" exact component={props => <Mainpage />} />

                    <SecondaryLayout path="/o-nas" exact component={Aboutus} />
                    <SecondaryLayout path="/nasza-kadra" exact component={Team} />
                    <SecondaryLayout path="/dlaczego-z-nami" exact component={WhyWithUs} />
                    <SecondaryLayout path="/nasz-sprzet" exact component={Equipment} />
                    <SecondaryLayout path="/obozy" exact component={Camps} />
                    <SecondaryLayout path="/obozy/:type" exact component={SpecificCamps} />
                    <SecondaryLayout path="/obozy/:type/:name" exact component={Camp} />
                    <SecondaryLayout path="/obozy/:type/:name/:rezerwacja" exact component={props => <Reservation {...props} />} />
                    <SecondaryLayout path="/dla-rodzicow" exact component={Forparents} />
                    <SecondaryLayout path="/rabaty" exact component={Discounts} />
                    <SecondaryLayout path="/nasze-osrodki/:slug" exact component={Resort} />

                    <Redirect exact from="/media" to="/media/galeria" />

                    <SecondaryLayout path="/media/galeria" exact component={Gallery} />
                    <SecondaryLayout path="/media/videoteka" exact component={Videoteka} />
                    <SecondaryLayout path="/opinie" exact component={Opinions} />
                    <SecondaryLayout path="/kontakt" exact component={props => <Contact {...props} />} />
                    <SecondaryLayout path="/blog" exact component={Blog} />
                    <SecondaryLayout path="/faq" exact component={Faq} />
                    <SecondaryLayout path="/warunki-uczestnictwa" exact component={TermsOfParticipations} />
                    <SecondaryLayout path="/ubezpieczenie-kosztow-imprezy-turystycznej" exact component={Insurance} />
                    <SecondaryLayout path="/blog/kategoria/:param?" exact component={Blog} />
                    <SecondaryLayout path="/blog/tag/:param?" exact component={Blog} />
                    <SecondaryLayout path="/blog/artykul/:slug" exact component={Article} />
                    <SecondaryLayout path="/podroz/:_turnus?" exact component={Transport} />
                    <SecondaryLayout path="/polityka-ciasteczek" exact component={CookiesPolicy} />
                    <SecondaryLayout path="/polityka-prywatnosci" exact component={PrivacyPolicy} />

                    <SecondaryLayout path="/404" component={NotFound} />
                    <Redirect to="/404" />
                </Switch>
                </Suspense>
                {/* <Cookies /> */}
            </div>
        </>
    )
}
